export default "__VITE_ASSET__B4ea9725__"